// import Config from '@/hostConfig'
import { Notification } from 'element-ui'
import * as Sentry from '@/extend/sentry'
const Config = process.env

const maskerConfig = {
  env: Config.VUE_APP_STATUS,
  globalBtn: {
    show: true // 是否展示
  },
  // 萨德对hashstate变化有做处理,默认会重置萨德状态
  closeAutoToggle: true,
  closeAutoClear: true,
  request: {
    // url: Config.VUE_APP_API + '/call-center/callCenter/convertOriginalTextBatch', // 解密接口url
    url: Config.VUE_APP_HOST_THAAD + '/thaad/getOriginalTextBatch',
    headers: {
      'from-app': 'qmove-customer-service-workbench' // 来源标识，package.json中的serverName
    }
  },
  rules: [
    {
      type: 'logoutUserName',
      match: /已注销/,
      request: false,
      format: str => str
    },
    // 自定义rules，对于以下需要加密但是后端直接返回的拼接字段进行特殊处理
    {
      type: 'ALL',
      match: /已支付总运费/,
      request: false,
      format: str => '******'
    },
    // 自定义rules，对于以下需要加密但是后端直接返回的拼接字段进行特殊处理
    {
      type: 'NUMBER_WITH_PLUS',
      match: /^\+\d*/,
      request: false,
      format: str => '******'
    }
  ],
  onRequestEnd(e) {},
  onRequestError(e) {
    const windowLibTrack = window.lib && window.lib.track
    windowLibTrack?.error?.('萨德解密错误', {
      stack: e,
      type: 'thaad-error'
    })
    if (!e.status && !e.response) {
      Notification({
        type: 'error',
        title: '萨德解密错误',
        message: '请求萨德服务失败，请刷新重试！'
      })
    } else {
      Notification({
        type: 'error',
        title: '萨德解密错误',
        message: _.get(e, 'response.errorMsg') || '解密错误，请刷新重试！'
      })
    }
    try {
      Sentry.captureException(e)
    } catch (e) {
      console.error(e)
    }
  }
}
export default maskerConfig

export const CustomRules = {
  // 将明文手机号 萨德加密
  telephone: {
    type: 'TELEPHONE_TO',
    match: /^1\d{10}$/,
    request: false,
    format: str => str.substring(0, 3) + '****' + str.substring(7)
  }
}
